import {MessageTextChunk} from './chat-message'
import {DataObjectId} from './data-object'

export const getMatchedMentions = (
  text: string
): {userId: DataObjectId; match: string}[] => {
  /* Parse special chat shortcodes */
  const shortCodeRegex = /\[!([^:\]]+):([^\]!]+)!]/g

  let match

  const allMatches: string[][] = []
  const allHandledShortcodes: string[] = []
  const mentions: {userId: DataObjectId; match: string}[] = []

  while ((match = shortCodeRegex.exec(text)) !== null) {
    allMatches.push(match)
  }

  for (const match of allMatches) {
    if (allHandledShortcodes.includes(match[0])) {
      continue
    }

    allHandledShortcodes.push(match[0])

    const command = match[1]
    const data = match[2]

    if (command === 'mention') {
      mentions.push({userId: data as DataObjectId, match: match[0]})
    }
  }

  return mentions
}

export const getChunksWithFixedText = (
  text: string,
  mentions: {userId: DataObjectId; match: string; name: string}[]
): {text: string; chunks: MessageTextChunk[]} => {
  const chunks: MessageTextChunk[] = []
  for (const {userId, match, name} of mentions) {
    chunks.push({
      type: 'user',
      replacement: `@${name}`,
      data: {userId}
    })
    text = text.replaceAll(match, `@${name}`)
  }

  return {text, chunks}
}
